<template>
    <div class="chart-wrap">
        <div class="chart" ref="chart" v-show="!isEmpty"></div>
        <no-result v-show="isEmpty"></no-result>
    </div>
</template>

<script>
    import '@/common/js/common-plugins';
    import NoResult from '../../../components/common/NoResult'

    const option = {
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data:['快捷收款','完美还款','极速还款']
        },
        toolbox: {
            show: true,
            feature: {
                // dataZoom: {show:true},
                magicType: {type: ['line', 'bar']},
                // restore: {show: true},
                saveAsImage: {show: true,pixelRatio:2,name:'交易额走势图' +   new Date().format('yyyyMMddHHmmss')}
            },
            right:20
        },
        xAxis:  {
            type: 'category',
            boundaryGap: false,
            // data: ['2019-10-20','2019-10-21','2019-10-24','2019-10-25','2019-10-26','2019-10-27','2019-10-28']
        },
        yAxis: [{
            type: 'value',
            name: '单位：元',
        }],
        series: [
            {
                name:'快捷收款',
                type:'line',
                smooth: true,
                symbolSize: 10,
                // data:[11, 11, 15, 13, 12, 13, 10],
                // markPoint: {
                //     data: [
                //         {type: 'max', name: '最大值'},
                //         {type: 'min', name: '最小值'}
                //     ]
                // },
                // markLine: {
                //     data: [
                //         {type: 'average', name: '平均值'}
                //     ]
                // }
            },
            {
                name:'完美还款',
                type:'line',
                smooth: true,
                symbolSize: 10,
                // data:[1, 2, 2, 5, 3, 2, 0],
                // markPoint: {
                //     data: [
                //         {type: 'max', name: '最大值'},
                //         {type: 'min', name: '最小值'}
                //     ]
                // },
                // markLine: {
                //     data: [
                //         {type: 'average', name: '平均值'}
                //     ]
                // }
            },
            {
                name:'极速还款',
                type:'line',
                smooth: true,
                symbolSize: 10,
                // data:[1, 2, 8, 5, 3, 2, 0],
                // markPoint: {
                //     data: [
                //         {type: 'max', name: '最大值'},
                //         {type: 'min', name: '最小值'}
                //     ]
                // },
                // markLine: {
                //     data: [
                //         {type: 'average', name: '平均值'}
                //     ]
                // }
            },
        ],
        color:['#079ADE','#FF6867','#FFAE2E']
    };


    export default {
        name: "TranMoneyChart",
        components: {
            NoResult
        },
        data() {
            return {
                isEmpty: false,
            };
        },
        props:{
            params:{
                type:Object,
                default:() => {},
            }
        },
        mounted() {
            this.init(); // 初始化图表
            // this.getData(this.params); //获取图表所需数据
        },
        watch:{
            params(newVal,oldVal){
                if (newVal) {
                    this.getData(newVal); //获取图表所需数据
                } else {
                    this.getData(oldVal); //获取图表所需数据
                }
            },
        },
        methods: {
            init() {
                this.charts = this.$echarts.init(this.$refs.chart);
                this.charts.setOption(option);
            },
            getData(params){
                let fastList = 0;
                let perfList = 0;
                let quickList = 0;

                params.fastList.forEach(item => {
                    fastList += parseInt(item);
                });
                // console.log(fastList)

                params.perfList.forEach(item => {
                    perfList += parseInt(item);
                });

                params.quickList.forEach(item => {
                    quickList += parseInt(item);
                });

                // console.log(fastList + perfList + quickList == 0)

                if (fastList + perfList + quickList == 0) {
                    this.isEmpty = true;
                } else {
                    this.isEmpty = false;
                }
                this.charts.setOption(option);
                this.formatData(params); // 图表数据
            },
            formatData(data) {

                this.charts.setOption({
                    series: [{
                        data: data.quickList
                    },{
                        data: data.perfList
                    },{
                        data: data.fastList
                    },],
                    xAxis:  {
                        data: data.timeList
                    },
                });
            },

        }
    };

</script>

<style scoped>
    .chart-wrap{
        width: 100%;
        height: 500px;
    }
    .chart{
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/echarts/TranMoneyChart.vue